import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'
import { STORAGE_KEYS } from '@/constants'

const { THEME } = STORAGE_KEYS

const useThemeStore = defineStore('theme', () => {
  const theme = useStorage(THEME, 'light')

  const setTheme = (newTheme: string) => {
    theme.value = newTheme
    document.documentElement.setAttribute('data-theme', newTheme)
    document.documentElement.setAttribute('arco-theme', newTheme)
  }

  const toggleTheme = () => {
    const newTheme = theme.value === 'light' ? 'dark' : 'light'
    setTheme(newTheme)
  }

  const isDark = () => {
    return theme.value === 'dark'
  }

  setTheme(theme.value)

  const ink400 = theme.value == 'light' ? '#A4A7AE' : '#5F6777'

  const success500 = theme.value == 'light' ? '#17B26A' : '#128E55'
  const warning500 = theme.value == 'light' ? '#F79009' : '#DE8208'
  const danger500 = theme.value == 'light' ? '#F04438' : '#C0362D'

  const success50030 = theme.value == 'light' ? 'rgba(23, 178, 106, 0.3)' : 'rgba(18, 142, 85, 0.3)'
  const danger50030 = theme.value == 'light' ? 'rgba(240, 68, 56, 0.3)' : 'rgba(192, 54, 45, 0.3)'

  const success50000 = theme.value == 'light' ? 'rgba(23, 178, 106, 0)' : 'rgba(18, 142, 85, 0)'
  const danger50000 = theme.value == 'light' ? 'rgba(240, 68, 56, 0)' : 'rgba(192, 54, 45, 0)'

  return {
    theme,
    setTheme,
    toggleTheme,
    isDark,
    ink400,
    success500,
    warning500,
    danger500,
    success50030,
    danger50030,
    success50000,
    danger50000,
  }
})

export default useThemeStore
